import { getDeviceDetect } from './device-detect'

export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export function isIOS() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export function isHuawei() {
  const userAgent = navigator.userAgent || navigator.vendor || ''
  return /huawei/i.test(userAgent)
}

export function getDeviceInfo() {
  const { browserName, mobileModel, isMobile } = getDeviceDetect()
  return {
    browserName,
    mobileModel,
    userAgent: navigator.userAgent,
    type: isMobile ? 2 : 1,
  }
}

export function isInsideFacebook() {
  const userAgent = navigator.userAgent || ''
  const vendor = navigator.vendor || '' 
  const opera = (window as Window & { opera?: string }).opera ?? ''
  const ua = userAgent || vendor || opera
  return ua.includes('FBAN') || ua.includes('FBAV')
}

export function isCaptureSupported() {
  if (isInsideFacebook()) return false
  return getDeviceDetect().isChrome || isSafari()
}

export function isPWA() {
  // Check for standalone display mode (most reliable for most browsers)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }
  
  // Check for minimal-ui or fullscreen display modes (also PWA indicators)
  if (
    window.matchMedia('(display-mode: minimal-ui)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  ) {
    return true
  }
  
  // iOS Safari specific check
  if (
    typeof window.navigator !== 'undefined' &&
    window.navigator.standalone === true
  ) {
    return true
  }
  
  return false
}
